import React, { useState, useEffect } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
} from '@mui/material';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

// App-level environment preferences only. Database credentials and licensing
// codes are infrastructure concerns and are intentionally NOT editable here.
const EnvironmentSettings = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [appName, setAppName] = useState('BharatStore');
  const [appMode, setAppMode] = useState('Live');
  const [appUrl, setAppUrl] = useState('');

  useEffect(() => {
    const env = settings.custom?.environment;
    if (!env) return;
    if (env.appName !== undefined) setAppName(env.appName);
    if (env.appMode !== undefined) setAppMode(env.appMode);
    if (env.appUrl !== undefined) setAppUrl(env.appUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleSubmit = async () => {
    try {
      await updateSettings({
        custom: { environment: { appName, appMode, appUrl } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
      <CardContent>
        <Typography variant="h6" color="text.primary" gutterBottom>
          Environment
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Application-level preferences. Database and infrastructure settings are
          managed on the server, not here.
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="App Name"
              value={appName}
              onChange={(e) => setAppName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="app-mode-select-label">App Mode</InputLabel>
              <Select
                labelId="app-mode-select-label"
                value={appMode}
                label="App Mode"
                onChange={(e) => setAppMode(e.target.value)}
              >
                <MenuItem value="Live">Live</MenuItem>
                <MenuItem value="Maintenance">Maintenance</MenuItem>
                <MenuItem value="Development">Development</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="App URL"
              placeholder="https://bharatstore.org"
              value={appUrl}
              onChange={(e) => setAppUrl(e.target.value)}
            />
          </Grid>
        </Grid>

        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 3 }}>
          <Button variant="contained" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? 'Saving…' : 'Save'}
          </Button>
        </Stack>

        <SaveSnackbar snack={snack} onClose={closeSnack} />
      </CardContent>
    </Card>
  );
};

export default EnvironmentSettings;
